<template>
  <section class="section has-text-centered">
    <div class="container">
      <p class="title is-size-4">Recordings</p>
      <p class="subtitle">A list with all your recordings.</p>
      <RecordingsTable :tableData="tableData" />
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import RecordingsTable from "./RecordingsTable";
export default {
  components: { RecordingsTable },
  props: ["recordings"],
  computed: {
    ...mapGetters(["getBookById"]),
    tableData() {
      return this.recordings.map(r => ({
        ...r,
        bookName: this.getBookById(r.bookId).name
      }));
    }
  }
};
</script>

<style lang="scss" scoped></style>
